import axios from "@/helpers/axios";

export default {
  namespaced: true,
  state: {
    main: [],
    order: [],
  },
  mutations: {
    updateOrder(state, payload) {
      state.order.push(payload);
    },
    updateMain(state, payload) {
      state.main.push(payload);
    },
  },
  actions: {
    updateOrder({ commit, state }, payload) {
      // 다시보지않기 목록에 없는 경우에만 추가
      if (state.order.includes(payload)) return;
      else commit("updateOrder", payload);
    },
    checkOrder({ state }, payload) {
      if (state.order.includes(payload)) return "noShow";
      return "show";
    },
    updateMain({ commit, state }, payload) {
      // 다시보지않기 목록에 없는 경우에만 추가
      if (state.main.includes(payload)) return;
      else commit("updateMain", payload);
    },
    checkMain({ state }, payload) {
      if (state.main.includes(payload)) return "noShow";
      return "show";
    },
  },
  getters: {},
};
